export const EMPLOYEE_LIST_FETCH = 'EMPLOYEE_LIST_FETCH';
export const EMPLOYEE_LIST_SUCCESS = 'EMPLOYEE_LIST_SUCCESS';
export const EMPLOYEE_LIST_FAILURE = 'EMPLOYEE_LIST_FAILURE';

export const DELETE_EMPLOYEE_FETCH = 'DELETE_EMPLOYEE_FETCH';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_FAILURE = 'DELETE_EMPLOYEE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/EmployeeList/actionTypes.js